import { ENUM_HelpCaseType } from '@api-new/common';

export const ENUM_HelpCaseTypeMap: Map<ENUM_HelpCaseType, string> = new Map([
  [ENUM_HelpCaseType.HELP_CASE_TYPE_UNSPECIFIED, 'Unspecified'],
  [ENUM_HelpCaseType.HELP_CASE_TYPE_BORROW_MORE_MONEY, 'Borrow more money'],
  [ENUM_HelpCaseType.HELP_CASE_TYPE_MOVE_HOME, 'Move home'],
  [ENUM_HelpCaseType.HELP_CASE_TYPE_FIRST_TIME_BUYER, 'First time buyer'],
  [ENUM_HelpCaseType.HELP_CASE_TYPE_BUY_TO_LET, 'Buy to let'],
  [ENUM_HelpCaseType.HELP_CASE_TYPE_EXTRA_PAYMENT, 'Extra payment'],
  [ENUM_HelpCaseType.HELP_CASE_TYPE_HELP_ME, 'Help me'],
  [ENUM_HelpCaseType.HELP_CASE_TYPE_PROPERTY_ENQUIRES, 'Property enquires'],
  [ENUM_HelpCaseType.HELP_CASE_TYPE_ADJUST_BALANCE, 'Adjust balance'],
  [ENUM_HelpCaseType.HELP_CASE_TYPE_RESUME_MORTGAGE_CASE_CREATION, 'Resume comparison'],
  [ENUM_HelpCaseType.UNRECOGNIZED, 'Unrecognized'],
]);
